import http from "../http-common";

class AssetDataService {
  getAll() {
    return http.get("/asset/api/assets");
  }

  getDevices(code) {
    return http.get(`/api/v1/device/list?companyCode=${code}`)
  }

  addDevice(payload) {
    return http.post("/api/v1/device/new", payload)
  }

  addAssettoDevice(deviceId, payload) {
    return http.put(`/api/v1/device/${deviceId}`, payload)
  }

  get(id) {
    return http.get(`/asset/api/assets/${id}`);
  }

  create(data) {
    return http.post("/asset/api/assets", data);
  }

  import(data) {
    return http.post("/asset/api/import", data);
  }

  update(id, data) {
    return http.put(`/asset/api/assets/${id}`, data);
  }

  delete(id) {
    return http.delete(`/asset/api/assets/${id}`);
  }

  deleteAll() {
    return http.delete(`/asset/api/assets`);
  }

  findByCountryCode(countryCode) {
    return http.get(`/asset/api/assets/country?countryCode=${countryCode}`);
  }

  findByCompanyCode(companyCode) {
    return http.get(`/asset/api/assets/company?companyCode=${companyCode}`);
  }

}

export default new AssetDataService();
